module.exports = __webpack_public_path__ + "img/card.b9c584e2.png";